import * as React from 'react';
import Axios, { AxiosResponse } from 'axios';
import { IMedia, ITag, IPagination } from '../interfaces';
import config from '../config';
import Pagination from '../components/common/Pagination';
import { withTranslation } from 'react-i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';
import { NavLink } from 'react-router-dom';

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    isLoading: boolean,
    channels: any[],
    blocks: any[],
    tags: any[],
    tag_id: number,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
}

class Tv extends React.Component<any, IState>{
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: true,
            channels: [],
            blocks: [],
            tag_id: null,
            tags: [],
            currentPage: 1,
            totalPages: 1,
            pages: null,
        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    async componentDidMount() {
        await this.loadBlocks();
        await this.loadTags();
        await this.loadChannels();
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    async loadChannels() {
        cancel && cancel();

        this.setState({
            isLoading: true,
            channels: [],
        }, async () => {
            try {
                let response: AxiosResponse = await Axios.get(`https://api.new.mediabox.uz/v2/tv/channels?per-page=100`, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                let { data } = response;

                if (!this._isUnmounted) {
                    this.setState({
                        channels: data.data,
                        isLoading: false,
                    });
                }
            } catch (err) {

            }
        })
    }

    async loadBlocks() {
        cancel && cancel();
        try {
            let response: AxiosResponse = await Axios.get(`${config.host}/default/blocks`, {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            });

            let { data } = response;

            if (!this._isUnmounted) {
                this.setState({
                    blocks: data.blocks,
                });
            }
        } catch (err) {

        }
    }

    async loadTags() {
        let response: AxiosResponse = await Axios.get(`https://api.new.mediabox.uz/v2/tv/categories?per-page=100`);

        if (!this._isUnmounted)
            this.setState({
                tags: response.data.data
            });
    }

    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            isLoading: true,
        }, this.loadChannels);
    }


    onTagChange(tag_id: number) {
        this.setState({
            tag_id,
            isLoading: true,
        }, this.loadChannels);
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Онлайн ТВ") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="fast_link">
                            <div className="title">{t("Онлайн ТВ")}</div>
                            <ul>
                                <li key={99999}>
                                    <a className={this.state.tag_id == null ? "fw-bold" : ""} onClick={() => {
                                        this.onTagChange(null);
                                    }}>{t("Все")}</a>
                                </li>
                                {this.state.tags.map((tag: any, index: number) => {
                                    return (<li key={index}>
                                        <a className={this.state.tag_id == tag.id ? "fw-bold" : ""} onClick={() => {
                                            this.onTagChange(tag.id);
                                        }}>{tag.name}</a>
                                    </li>);
                                })}
                            </ul>
                        </div>

                        {this.state.isLoading && <div className="carousel-placeholder"></div>}
                        {!this.state.isLoading && <div className="story_list">
                            <div className="row">
                                {this.state.channels.filter((channel: any) => channel.category_id == this.state.tag_id || this.state.tag_id == null).filter((channel: any) => this.state.blocks.indexOf(channel.id) == -1).map((channel: any, index: number) => {
                                    return (
                                        <div key={index} className="col-md-3 col-xs-6 must-6">
                                            <div className="pict_box border-radius-10">
                                                <div className="icons">
                                                    <NavLink to={"/tv/" + channel.id} className="view" >
                                                        <i className="fa fa-play-circle-o" style={{ fontSize: "49px" }}></i>
                                                    </NavLink>
                                                </div>
                                                <NavLink to={"/tv/" + channel.id} style={{ display: 'block', height: "100%", width: "100%" }}>
                                                    <img style={{ width: "100%", height: "100%" }} src={"https://" + window.location.host + "/uploads/tv/" + channel.id + ".jpg"} alt={channel.title} />
                                                </NavLink>
                                            </div>
                                            <h2 className="text-center spec-h2"> <NavLink className="spec-a" to={`/tv/${channel.id}`}> {channel.title} </NavLink> </h2>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>}
                        <Banner className="banner235" place={45} />

                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Tv);